import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';

import { AuthService } from '../../services/auth.service';
import { SidenavStateService } from '../../services/sidenav-state.service';
import { Session } from '../../shared/models';

@Component({
  standalone: false,
  selector: 'topbar',
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.css',
})
export class TopbarComponent {
  organizationName = '';
  userName = '';
  userInitials = '';
  isDarkMode = false;
  themeIcon = 'pi pi-moon';
  userMenuItems: MenuItem[] = [];

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly sidenavState: SidenavStateService,
  ) {
    this.restoreTheme();

    this.authService.sessionUpdated$.pipe(
      takeUntilDestroyed(),
    ).subscribe((session) => {
      this.applySession(session);
    });
  }

  toggleSideBar(): void {
    this.sidenavState.toggle();
  }

  toggleTheme(): void {
    this.isDarkMode = !this.isDarkMode;
    this.applyTheme();
  }

  goToProfile(): void {
    void this.router.navigateByUrl('/profile');
  }

  logout(): void {
    this.authService.logout().subscribe({
      next: () => {
        void this.router.navigateByUrl('/login');
      },
      error: () => {
        void this.router.navigateByUrl('/login');
      },
    });
  }

  private restoreTheme(): void {
    this.isDarkMode = localStorage.getItem('pi-signage-theme') === 'dark';
    this.applyTheme();
  }

  private applyTheme(): void {
    document.documentElement.classList.toggle('app-dark', this.isDarkMode);
    this.themeIcon = this.isDarkMode ? 'pi pi-sun' : 'pi pi-moon';
    localStorage.setItem('pi-signage-theme', this.isDarkMode ? 'dark' : 'light');
  }

  private applySession(session: Session | null): void {
    this.organizationName = session?.organization.name ?? '';
    this.userName = session?.user.name ?? '';
    this.userInitials = [
      session?.user.firstName.charAt(0),
      session?.user.lastName.charAt(0),
    ].join('').toUpperCase();
    this.userMenuItems = [
      {
        label: this.userName || 'Account',
        items: [
          {
            label: 'My Profile',
            icon: 'pi pi-user',
            command: () => {
              this.goToProfile();
            },
          },
          {
            separator: true,
          },
          {
            label: 'Logout',
            icon: 'pi pi-sign-out',
            command: () => {
              this.logout();
            },
          },
        ],
      },
    ];
  }
}
